// eslint-disable-next-line import/no-internal-modules
export { Note, NOTE_SIZES, P, PARAGRAPH_SIZES, H, HEADING_SIZES } from '@askyourteam-nz/react-library/dist/elements/text';
